export const APP_NAME = 'VK ENTERPRISE'
export const PERSIST_STORE_NAME = 'user'
export const REDIRECT_URL_KEY = 'redirectUrl'
